import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TableRow } from '../../../../shared-components/custom-table/custom-table.types';

/**
 * Example of a component-based cell renderer for eif-custom-table.
 *
 * Use it on a data column via `render` + `inputs`:
 * ```ts
 * {
 *   field: 'ApprovalState',
 *   render: TablePillCellComponent,
 *   inputs: (row) => ({ field: 'ApprovalState', variantMap: { Approved: 'success' } }),
 * }
 * ```
 * The table always injects the current `row`; extra inputs are merged on top.
 */
@Component({
	selector: 'eif-table-pill-cell',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: `<span class="tag-{{ variantClass }}">{{ displayValue }}</span>`,
	standalone: false,
})
export class TablePillCellComponent {
	@Input() row: TableRow;
	@Input() field: string = '';
	/** Maps a raw cell value to a tag-* class suffix (success, warning, info, error, neutral, primary). */
	@Input() variantMap: { [value: string]: string } = {};

	get displayValue(): string {
		return this.row?.[this.field] ?? '-';
	}

	get variantClass(): string {
		return this.variantMap[this.row?.[this.field]] ?? 'neutral';
	}
}
